export default "__VITE_PUBLIC_ASSET__2b8bfa42__"